/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Table_Column_TextInputs */



/**
* | output |
* | --- |
* | "Text" |
*
* @param {Editor_Table_Column_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_table_column_text = /** @type {((inputs?: Editor_Table_Column_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Column_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文章")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूलपाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto")
	return /** @type {LocalizedString} */ ("Text")
});